export const PROMO_TYPES = {
    SUPPLY: 'Promo::Supply',
    PERCENTAGE: 'Promo::Percentage',
    VIRTUAL_SET: 'Promo::VirtualSet',
    PROMO_ITEM_FIXED_PRICE: 'Promo::PromoItemFixedPrice',
    MIX: 'Promo::Mix',
    MIX1: 'Promo::Mix1',
    PERIODIC_PRICE_REDUCTION: 'Promo::PeriodicPriceReduction',
    PROMO_ITEM_PROMOTIONAL: 'Promo::PromoItemPromotional',
    SALES_TARGET: 'Promo::SalesTarget',
    REGULAR_PRICE: 'Promo::RegularPrice',
    WEIGHT_PERIODIC_PRICE_REDUCTION: 'Promo::WeightPeriodicPriceReduction',
    WEIGHT_REGULAR_PRICE: 'Promo::WeightRegularPrice',
    QUOTA: 'Promo::Quota',
    BONDED: 'Promo::Bonded',
    BONDED_PERCENTAGE: 'Promo::BondedPercentage',
    BONDED_QUOTA: 'Promo::BondedQuota',
    ADVERTISEMENT: 'Promo::Advertisement'
}
